import React, { useEffect, useState } from 'react';
import { FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@material-ui/core';

import { LabelName, Required } from '../../../../../utils';
import { withStyles } from '@material-ui/core/styles';

import './LinearScale.css';

const CustomRadio = withStyles({
  root: {
    '&$checked': {
      color: '#00B6A4',
    },
  },
  checked: {},
})(Radio);

export default function LinearScaleNormalView({
  data,
  setData,
  setError,
  ind,
  isRequired,
  globalStateData,
}) {
  const { minScaleLabel = '', maxScaleLabel = '', minScale, maxScale } = data.linearScaleValidation;

  const [selectedValue, setSelectedValue] = useState(
    globalStateData?.customFormData?.[ind]?.fieldValue?.toString() ?? '',
  );

  useEffect(() => {
    setError(null);
    setData(Number(selectedValue), ind);
  }, [selectedValue]);

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };

  return (
    <Grid container className="linear-scale-main-container">
      <Grid item style={{ marginBottom: '20px' }}>
        <LabelName>
          {data?.fieldName}
          {isRequired && <Required> *</Required>}
        </LabelName>
      </Grid>

      <Grid item container className="linear-scale-container">
        <Grid item sm={1}>
          <LabelName>{minScaleLabel}</LabelName>
        </Grid>

        <Grid item sm={10} className="linear-scale-radio-wrapper">
          <RadioGroup
            value={selectedValue}
            onChange={handleChange}
            className="linear-scale-radio-group"
          >
            {Array.from({ length: maxScale - minScale + 1 }, (_, i) => minScale + i).map(
              (scale) => (
                <div key={scale} className="radio-box">
                  <Typography style={{ padding: '0.25rem' }}>{scale}</Typography>
                  <FormControlLabel value={scale.toString()} control={<CustomRadio />} />
                </div>
              ),
            )}
          </RadioGroup>
        </Grid>

        <Grid item sm={1}>
          <LabelName>{maxScaleLabel}</LabelName>
        </Grid>
      </Grid>
    </Grid>
  );
}
